module.exports = __webpack_public_path__ + "37fe8f629f83ed5929e4d544ac67fd03.svg";